export const findCustomerInfoByRegNum = <T extends { regNum: string }>(
  customerInfo: T[],
  regNum: string,
) => customerInfo.filter((info) => info.regNum === regNum);
